import constants from "../../constants";
import useAxiosPrivate from "../useAxiosPrivate";
import ConnectPhoneHooks from "./ConnectPhoneHooks";
import { useContext, useRef, useState } from "react";
import AlertContext from "../../context/AlertContext";
import NotifyBody from "../../Components/Notify/NotifyBody";
import CodingTestHooks from "../CodingPage/CodingTestHooks";
import useCommonFunctionHooks from "../useCommonFunctionHooks";
import StudentTestPageHooks from "../StudentTestPage/StudentTestPageHooks";
import { getDataFromStorage } from "../../util";

export default function InstructionPageHooks() {
  const Alert = useContext(AlertContext);

  const axios = useAxiosPrivate();
  const { takeTest } = CodingTestHooks();
  const { startTest } = StudentTestPageHooks();
  const { validateToken } = ConnectPhoneHooks();

  const {  getCatchBlockDetails, getHeaderDetailsForAxios } =
    useCommonFunctionHooks();
  const isPreview = new URLSearchParams(window.location.search).get("mode") === "preview";


  const [audioAvailable, setAudioAvailable] = useState(false);

  const videoConstraints = {
    width: 181,
    height: 101,
    facingMode: "user",
  };

  const getButtonText = () => {
    if (Alert.testData.ainterview) {
      return "Attend Interview";
    } else if (Alert.status === constants.PROGRESS_STATUS.UNLOCKED) {
      return "Take Test";
    } else if (Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE) {
      return "Resume Test";
    } else if (isPreview) {
      return "Take Test";
    } else {
      return "Retake Test";
    }
  };

  const countNoOfdisplays = async () => {
    let count = await window?.electronAPI?.sendScreenInfo();
    let monitors = count?.monitors;

    return { monitors };
  };

  const checkRefreshTokenIsValid = async (payload) => {
    try {
      let res = await axios.post(
        "node/auth/refreshtoken/check",
        { ...payload, refreshToken: localStorage.getItem("refreshToken") },
        getHeaderDetailsForAxios()
      );

      if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
        if (
          Alert.testData.testtype === constants.libTypeIds.SQL ||
          Alert.testData.testtype === constants.libTypeIds.CODING_CHALLENGE
        ) {
          // console.log("Before going to takeTest inside valid token.");
          return takeTest(Alert.codingTestData);
        } else {
          // console.log("Before going to takeTest inside valid token..");
          return startTest();
        }
      } else if (
        res.data.resultCode === constants.RESULT_STATUS.TECHNICAL_ERROR
      ) {
        Alert.setIsLoaded(false);
        Alert.setShowNotify({
          show: true,
          title: "Warning",
          msg: res.data.msg,
          isUnAuth: res.data.msg.includes("session is expiring") && true,
        });
      } else {
        Alert.setIsLoaded(false);
        Alert.setShowNotify({
          show: true,
          title: "Warning",
          msg: "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      getCatchBlockDetails(error);
    }
  };

  const handleCheck = async () => {
    Alert.setIsLoaded(true);
    Alert.setButtonDisable(true);

    const isTabCamProctoring =
      Alert.testData.proctored === constants.PROCTORING_MODE.TAB_CAM ||
      Alert.testData.proctored === constants.PROCTORING_MODE.TAB_CAM_LOC;

    const shouldRequireLocation =
      Alert.testData.testmode === constants.MODE.TEST_MODE &&
      Alert.testData.proctored === constants.PROCTORING_MODE.TAB_CAM_LOC &&
      !isPreview;

    if (
      !Alert.testData.verifyPic &&
      Alert.testData.proctored === constants.PROCTORING_MODE.DUAL
    ) {
      await validateToken();
    }

    let count = await countNoOfdisplays();

    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    }

    if (
      window.screen.availWidth - window.innerWidth > 0 &&
      Alert.testData.testmode === constants.MODE.TEST_MODE
    ) {
      Alert.setIsLoaded(false);
      Alert.setButtonDisable(false);
      return Alert.setShowNotify({
        show: true,
        titleSvg: "warning",
        msg: "You are not in fullscreen. Please be in fullscreen to take the test.",
      });
    }

    if (
      Alert.testData.testmode !== constants.MODE.TEST_MODE &&
      !isTabCamProctoring
    ) {
      Alert.setIsTakeTest(false);
    }

    /* if (
      getDataFromStorage("registered") == 0 &&
      Alert.testData.testmode === constants.MODE.TEST_MODE &&
      Alert.testData.proctored !== constants.PROCTORING_MODE.TAB
    ) {
      Alert.setIsLoaded(false);
      Alert.setButtonDisable(false);
      Alert.setShowNotify({
        show: true,
        size: "lg",
        primaryButton: "Continue",
        secondaryButton: "Cancel",
        primaryButtonFunction: handleRegistration,
        title: "First time taking a proctored test.",
        msg: <NotifyBody component="instructionPageNotifyMsgForRegistration" />,
      });
    } else */ if (
      !Alert.camAvailable &&
      (Alert.testData.videoqn ||
        (Alert.testData.testmode === constants.MODE.TEST_MODE &&
          Alert.testData.proctored !== constants.PROCTORING_MODE.TAB))
    ) {
      Alert.setIsLoaded(false);
      Alert.setButtonDisable(false);
      Alert.setShowNotify({
        show: true,
        titleSvg: "warning",
        msg: <NotifyBody component="instructionPageNotifyMsgForCameraAccess" />,
      });
    } else if (
      !audioAvailable &&
      Alert.testData.testmode === constants.MODE.TEST_MODE && 
      Alert.testData.proctored !== constants.PROCTORING_MODE.TAB
    ) {
      Alert.setIsLoaded(false);
      Alert.setButtonDisable(false);
      Alert.setShowNotify({
        show: true,
        titleSvg: "warning",
        msg: <NotifyBody component="instructionPageNotifyMsgForAudioAccess" />,
      });
    } else if (shouldRequireLocation && !Alert.locationAvailable) {
      Alert.setIsLoaded(false);
      Alert.setButtonDisable(false);
      Alert.setShowNotify({
        show: true,
        titleSvg: "warning",
        msg: "Please allow location access to start this proctored test.",
      });
    } else if (
      Alert.testData.testtype === constants.libTypeIds.CODING_CHALLENGE
    ) {
      if (count?.monitors > 1) {
        Alert.setIsLoaded(false);
        Alert.setShowNotify({
          show: true,
          title: "Warning",
          msg: `You are connected to multiple displays, Please Ensure you are not connected to any external displays and start again!`,
        });
      } else {
        console.log("Before going into takeTest Function..");
        takeTest(Alert.codingTestData);
      }
    } else {
      Alert.setButtonDisable(false);

      let payload = {
        libtypeid: Alert.testData.testtype,
      };

      if (Alert.testData.testtype === constants.libTypeIds.CODING_CHALLENGE) {
        payload.testconfigid = Alert.codingTestData.testconfigid;
      } else {
        payload.testId = Alert.testData.testid;
      }

      if (count?.monitors > 1) {
        Alert.setIsLoaded(false);
        Alert.setShowNotify({
          show: true,
          title: "Warning",
          msg: `You are connected to multiple displays, Please Ensure you are not connected to any external displays and start again!`,
        });
      } else {
        return checkRefreshTokenIsValid(payload);
      }
    }
  };

  const removeAccess = () => {
    // console.log("Alert.currentStream", Alert.streamRef.current);

    if (Alert.streamRef.current) {
      // console.log("Stopping current stream...");
      Alert.streamRef.current.getTracks().forEach((track) => {
        // console.log(`${track.kind} = ${track.label} is on so turning off..`);
        track.stop();
        // console.log(`${track.kind} = ${track.label} turned off..`);
      });
      Alert.streamRef.current = null;
    } else {
      console.warn("No stream to stop!");
    }
  };
  return {
    handleCheck,
    videoConstraints,
    getButtonText,
    removeAccess,
    setAudioAvailable,
  };
}



